/**
 * @file src/pages/invoice-creation-wizard/useClearInvoice.js
 * @description React Query mutation hook for clearing an invoice through ZATCA.
 *
 * What changed:
 *  - Import from utils/invoiceApis → api/invoice.api.js
 *  - console.log/error removed
 *  - On success, invoice-side and dashboard query sources are invalidated
 *  - Callers handle feedback via toast
 */

import { useMutation, useQueryClient } from "@tanstack/react-query";

import { clearInvoice } from "api/invoice.api";
import {
  invalidateDashboardSources,
  invalidateInvoiceSide,
} from "lib/cacheInvalidation";

export const useClearInvoice = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id) => clearInvoice(id),
    onSuccess: () => {
      invalidateInvoiceSide(queryClient);
      invalidateDashboardSources(queryClient);
    },
  });
};
